import { Box, Text } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import type { Sync } from 'modules/payroll_integrations_a3innuva/lib/IncidenceSync/store'
import fieldTranslations from 'modules/payroll_integrations_a3innuva/lib/fieldTranslations'

const Unavailable = ({ sync }: { sync: Sync }) => {
  const unavailableFields = sync.unavailable_fields ?? []
  const employeeUnavailableFields = unavailableFields.filter(
    fieldTranslations.isEmployeeField.bind(fieldTranslations)
  )
  const contractUnavailableFields = unavailableFields.filter(
    fieldTranslations.isContractField.bind(fieldTranslations)
  )

  const fieldsToCheck = ['company_code', 'location_code', 'leave_type', 'job_position_a3_code']
  const mappingFields: string[] = []

  fieldsToCheck.forEach((field) => {
    if (unavailableFields.includes(field)) {
      mappingFields.push(field)
    }
  })

  return (
    <>
      {mappingFields.map((field) => (
        <Callout
          type="critical"
          title={i18n.t(
            'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.mapping_title',
            { field: fieldTranslations.t(field) }
          )}
          description={i18n.t(
            'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.mapping_message',
            { field: fieldTranslations.t(field) }
          )}
        />
      ))}

      {(employeeUnavailableFields.length > 0 || contractUnavailableFields.length > 0) && (
        <Callout
          type="critical"
          title={i18n.tp(
            'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.missing_title',
            { count: employeeUnavailableFields.length + contractUnavailableFields.length }
          )}
          description={i18n.tp(
            'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.missing_message',
            { count: employeeUnavailableFields.length + contractUnavailableFields.length }
          )}
        />
      )}

      {employeeUnavailableFields.length > 0 && (
        <Box
          background="radicalRed200"
          paddingX="s24"
          paddingY="s16"
          borderRadius={{
            all: 'abs008',
          }}
          gap="s16"
        >
          <>
            <Box component="ul">
              <Text.Header3>
                {i18n.t(
                  'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.employee_data'
                )}
              </Text.Header3>
              {(employeeUnavailableFields as string[]).map((field) => (
                <Box component="li" key={field} paddingX="s8">
                  {fieldTranslations.t(field)}
                </Box>
              ))}
            </Box>
          </>
        </Box>
      )}

      {contractUnavailableFields.length > 0 && (
        <Box
          background="radicalRed200"
          paddingX="s24"
          paddingY="s16"
          borderRadius={{
            all: 'abs008',
          }}
          gap="s16"
        >
          <>
            <Box component="ul">
              <Text.Header3>
                {i18n.t(
                  'payroll_integrations.incidences.a3innuva.configuration_unavailable_fields.contract_data'
                )}
              </Text.Header3>
              {(contractUnavailableFields as string[]).map((field) => (
                <Box component="li" key={field} paddingX="s8">
                  {fieldTranslations.t(field)}
                </Box>
              ))}
            </Box>
          </>
        </Box>
      )}
    </>
  )
}

export default Unavailable
